export { default } from './ActivityToTrigger';
